export default __webpack_public_path__ + "static/file-c4edbd2cea13e658d98546ab5feba2b6.png";